import React from 'react'
import { startCase } from 'lodash'
import type { Rental_Program_Types_Enum_Enum } from 'graphql/generated'
import { mapContentToBadge, BadgeOptionOverrides } from 'components/TailwindUIToolkit/badges'
import { getProgramLeaseTypeForRental } from 'lib/rentals'

const RPP_LEASE_LABEL = 'RPP Lease'

type RentalLeaseTypeData =
  | { lease_variant?: string | null; rental_program_type?: Rental_Program_Types_Enum_Enum | null }
  | null
  | undefined

const getRentRollLeaseTypes = (rental: RentalLeaseTypeData): string[] => {
  const program = getProgramLeaseTypeForRental(
    rental ? { rental_program_type: rental.rental_program_type ?? undefined } : rental
  )
  return [program, rental?.lease_variant === 'kcpoa' ? RPP_LEASE_LABEL : undefined].filter(
    (label): label is string => !!label
  )
}

// Keep the existing grid value for non-RPPs; include both labels for RPP search/filter/export.
export const getRentRollLeaseType = (rental: RentalLeaseTypeData) => {
  const labels = getRentRollLeaseTypes(rental)
  return labels.includes(RPP_LEASE_LABEL)
    ? labels.map((label) => startCase(label).replace('Upandup', 'Up&Up')).join(' · ')
    : labels[0]
}

export const renderRentRollLeaseTypeBadges = (
  rental: RentalLeaseTypeData,
  options: BadgeOptionOverrides = {}
) => {
  const labels = getRentRollLeaseTypes(rental)
  if (!labels.length) return null
  return (
    <span className='inline-flex flex-wrap items-center gap-2'>
      {labels.map((label) => (
        <React.Fragment key={label}>
          {mapContentToBadge(label, {
            ...options,
            ...(label === RPP_LEASE_LABEL
              ? { colorOverride: 'Purple', hoverText: 'Resident Purchase Program (RPP)' }
              : {})
          })}
        </React.Fragment>
      ))}
    </span>
  )
}
